import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { IStepValidation, WizardStep } from '../../../WizardStep';
import { IMessage } from '../../../../../store/models/message.model';
import { IUserSessionData, UserType } from '../../../../../store/models/user.model';
import { Subject } from 'rxjs';
import { SessionService } from '../../../../../store/services/session.service';
import { takeUntil } from 'rxjs/operators';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ButtonColor, ButtonSize } from '../../../../../store/models/button.model';
import { IContactGroup } from '../../../../../store/models/contact.model';
import { ContactsService } from '../../../../../store/services/contacts.service';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { openDialog } from '../../../../../store/actions/page.action';
import { Store } from '@ngrx/store';
import { IReducers } from '../../../../../store/reducers';
import { ISelectItem } from '../../../../../store/models/select.model';

@Component({
  selector: 'app-create-new-contact',
  templateUrl: './create-new-contact.component.html',
  styleUrls: ['./create-new-contact.component.scss'],
})
export class CreateNewContactComponent
  implements OnInit, WizardStep, OnDestroy {
  static ID = 'create-new-contact';

  wizardData: { [p: string]: any };

  messages: IMessage[];
  componentReady: boolean;
  contactEmail: string;
  sessionData: IUserSessionData;
  showGroupControl: boolean;
  accountId: number;
  emailValidationTriggered: boolean;
  emailValidationInProgress: boolean;
  emailAddressValid: boolean;
  iconCheck = faCheck;
  iconTimes = faTimes;

  formGroup: FormGroup;

  contactGroupsItems: ISelectItem[] = [];

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly sessionService: SessionService,
    private readonly contactService: ContactsService,
    private readonly store: Store<IReducers>,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {
  }

  get email(): AbstractControl {
    return this.formGroup.get('email');
  }

  get group_id(): AbstractControl {
    return this.formGroup.get('group_id');
  }

  get group_name(): AbstractControl {
    return this.formGroup.get('group_name');
  }

  checkNewGroup(value: string) {
    this.contactService
      .checkExistingGroup(value)
      .subscribe((groups: IContactGroup[]) => {
        if (groups.length === 1 && groups[0].group_name === value) {
          this.group_id.setValue(groups[0].group_id);
          this.showGroupControl = false;
        }
      });
  }

  onGroupSelection(value) {
    this.showGroupControl = value === 0;

    if (value === 0) {
      this.group_name.setValidators(Validators.required);
    }

    if (value === 8591) {
      this.store.dispatch(
        openDialog({
          dialogData: {
            title: `Campaign Email`,
            content: `Warning, you have selected No Campaign. Contacts associated with the No Campaign Group do not receive campaign emails.`,
            dialogMinWidth: '1000px',
            canClose: true,
            buttons: [
              {
                text: 'Ok',
                actAsClose: true,
                color: ButtonColor.GREEN,
                size: ButtonSize.NORMAL,
              },
              {
                text: 'Close',
                actAsClose: true,
                color: ButtonColor.RED,
                size: ButtonSize.NORMAL,
                onClick: () => this.deselectGroup(),
              },
            ],
          },
        }),
      );
    }
  }

  deselectGroup() {
    this.group_id.setValue('new');
  }

  ngOnInit(): void {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(session => {
        this.sessionData = session;
        this.contactService
          .getContactGroups(this.sessionData.user_type === UserType.VSM ? this.accountId : this.sessionData.id)
          .subscribe((groups: IContactGroup[]) => {
              this.contactGroupsItems = [
                {
                  label: 'Add new',
                  value: 0,
                },
              ];
              groups.forEach((group: IContactGroup) =>
                this.contactGroupsItems.push({
                  label: group.group_name,
                  value: group.group_id,
                }),
              );
              this.changeDetectorRef.detectChanges();
            },
          );

        this.formGroup = new FormGroup({
          group_id: new FormControl('', [Validators.required]),
          group_name: new FormControl(''),
          email: new FormControl(this.contactEmail, [
            Validators.required,
            Validators.email,
          ]),
          firstname: new FormControl(''),
          lastname: new FormControl(''),
          company: new FormControl(''),
          title: new FormControl(''),
          phone_number: new FormControl(''),
        });
        this.componentReady = true;
      });
  }

  provideData(): any {
    const data = this.formGroup.value;

    if (!this.showGroupControl) {
      delete data.group_name;
    }
    return data;
  }

  async validate(): Promise<IStepValidation> {
    if(!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();

      return {
        success: false,
      };
    }

    return {
      success: true,
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
